import React from 'react';
import Contact from './components/contact/Contact';
import Experience from './components/experience/Experience';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Intro from './components/intro/Intro';
import Testimonials from './components/testimonials/Testimonials';
import Topbar from './components/topbar/Topbar';
import Portfolio from './components/portfolio/Portfolio';
import {useState,useEffect} from 'react';
import { ThemeProvider } from "@material-tailwind/react";

import axios from 'axios';
export const UserContext = React.createContext();
const App = () => {
  const [state, setState] = useState();
  useEffect(()=>{
    let mounted = true;
     axios.get(`http://13.235.81.45/api/getProfileInfo`).then((res)=>{
      if(mounted) {
        setState(res.data.data)
      }
    })
    return () => mounted = false;
  },[])
  return (
    <>
        <ThemeProvider>
      <UserContext.Provider value={state}>
      <Header />
      <Topbar />
      <Intro />
      <Portfolio/>
      <Experience />
      <Testimonials />
      <Contact />
      <Footer />
      </UserContext.Provider>
      </ThemeProvider>
    </>
  )
}

export default App
